import React, { FC } from 'react';

import { Container, Wrapper, Text, SubText, DotLoader } from './LoaderStyle';

export interface LoaderProps {
  text?: string;
  subText?: string;
  src?: string;
}

const Loader: FC<LoaderProps> = ({
  text,
  subText,
  src = '/static/images/loader.gif',
}) => (
  <Container>
    {text || subText ? (
      <Wrapper>
        {text ? <Text>{text}</Text> : null}
        {subText ? <SubText>{subText}</SubText> : null}
      </Wrapper>
    ) : null}
    <DotLoader alt='loader' src={src} />
  </Container>
);

export default Loader;
